import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GhostParagraphModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-paragraph';
import { GhostTitleModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-title';
import { GhostProductMediaModule } from 'apps/ecommerce-shop/src/app/core/shop-ui/components/ghost-loading/ghost-product-media';
import { GhostPageRowComponent } from './ghost-page-row.component';

@NgModule({
  declarations: [GhostPageRowComponent],
  exports: [GhostPageRowComponent],
  imports: [CommonModule, GhostTitleModule, GhostParagraphModule, GhostProductMediaModule],
})
export class GhostPageRowModule {}
